import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatDataTable = createCustomElementWrapper('kat-data-table', 'KatDataTable', {
    'titleLabel': 'title-label',
}, {
    'onRowDataChanged': 'rowDataChanged',
    'onSelectAll': 'selectAll',
    'onSelectRow': 'selectRow',
    'onSelectionChanged': 'selectionChanged',
    'onSettingsChanged': 'settingsChanged',
    'onSortColumnChanged': 'sortColumnChanged',
    'onUnselectAll': 'unselectAll',
    'onUnselectRow': 'unselectRow',
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/katal-react/es/data-table.js
// module id = 1255
// module chunks = 0